import { Skeleton } from "@ui/skeleton";
import { CollectionShell } from "./collectionShell";
import { type DashboardCollectionProps } from "./useCollection";

export function DashboardList<T>(props: DashboardCollectionProps<T>) {
  return (
    <CollectionShell
      props={props}
      variant="list"
      feedbackSurface="plain"
      skeleton={
        <div className="p-6 space-y-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-12 w-full rounded-xl" />
          ))}
        </div>
      }
      renderBody={(pageItems) =>
        pageItems.map((item, i) => (
          <div key={props.getItemKey(item, i)}>{props.renderItem(item, i)}</div>
        ))
      }
    />
  );
}
